export function getPinInfoOriginal(data) {
    var x = getPinInfo(data);
    return { pinClass: `fas pin-${x.pinType}`, pinTitle: x.pinTitle };
}
export function getPinInfo(data) {
    let { pinType, pinTitle } = getBasePinInfo(data);
    if (pinType === "pmp" || pinType === "pm")
        ({ pinType, pinTitle } = getParkMarkAugmentations(data, pinType, pinTitle));
    else if (pinType === "pa" || pinType === "paev")
        ({ pinType, pinTitle } = getParkAccessAugmentations(data, pinType, pinTitle));
    return { pinType, pinTitle };
}
function getBasePinInfo(data) {
    let pinType = "";
    let pinTitle = "Awarded:";
    if (data.hasPmf) {
        pinType = "pmf";
        pinTitle += " Park Mark Freight";
    }
    else if (data.hasAmGo) {
        pinType = "amgo";
        pinTitle += " Park Mark, AM-GO";
    }
    else if (data.hasPmp) {
        pinType = "pmp"; //getParkMarkAugmentations
        pinTitle += " Park Mark, Park Mark Plus";
    }
    else if (!data.hasPm && data.hasPa && !data.hasPaEv) {
        pinType = "pa";
        pinTitle += " Park Access";
    }
    else if (!data.hasPm && data.hasPaEv) {
        pinType = "paev";
        pinTitle += " Park Access, Park Access EV";
    }
    else if (!data.hasPm && data.hasPAct) {
        pinType = "pact";
        pinTitle += " Park Active";
    }
    else {
        pinType = "pm"; //getParkMarkAugmentations
        pinTitle += " Park Mark";
    }
    return { pinType, pinTitle };
}
function getParkMarkAugmentations(data, pinType, pinTitle) {
    if (data.hasPa && !data.hasPaEv) {
        pinType += "_pa";
        pinTitle += ", Park Access";
    }
    else if (data.hasPaEv) {
        pinType += "_paev";
        pinTitle += ", Park Access, Park Access EV";
    }
    ({ pinType, pinTitle } = getParkAccessAugmentations(data, pinType, pinTitle));
    return { pinType, pinTitle };
}
function getParkAccessAugmentations(data, pinType, pinTitle) {
    if (data.hasPAct) {
        pinType += "_pact";
        pinTitle += ", Park Active";
    }
    return { pinType, pinTitle };
}
export function getFilters() {
    return [
        //we currently have to keep in sync using index only
        //id in html is "generated" using cpfHelp.idify(this.data.name) in FilterBtn so id's for less are NOT the ones in use here...
        //awards
        new FilterData("pm", "Park Mark", "Park Mark Accreditation", "bcs_pm", true),
        new FilterData("pmp", "Park Mark Plus", "Park Mark Plus Accreditation", "bcs_pmp", true, ["pm"]),
        new FilterData("pa", "Park Access", "Park Access Accreditation", "bcs_pa", true),
        new FilterData("am-go", "AM-GO", "AM-GO (Approved Meet & Greet Operator) Accreditation", "bcs_am-go", true, ["pm", "airport"], //https://trello.com/c/bsPNVhV5/217-remove-mg-airport-filters //["pm", "m&g", "airport"], 
        ["pmp", "pa", "pmf", "paev"]),
        new FilterData("pmf", "Park Mark Freight", "Park Mark Freight Accreditation (Lorry Parks and Truck Stops)", "bcs_pmf", true, [], //["lorry"], //https://trello.com/c/bsPNVhV5/217-remove-mg-airport-filters
        ["pm", "pmp", "pa", "am-go", "paev", "pact"]),
        new FilterData("paev", "Park Access EV", "Park Access EV Accreditation", "bcs_paev", true, ["pa"]),
        new FilterData("pact", "Park Active", "Park Active Accreditation", "bcs_pact", true),
        //misc
        new FilterData("ecp", "ECP", "Sites with a number of Electronic Charging Points", "fa-charging-station"),
        new FilterData("open24", "Open 24 Hours", "Sites Open 24 Hours (today)", "fa-alarm-clock"),
        //https://trello.com/c/bsPNVhV5/217-remove-mg-airport-filters new FilterData("m&g", "Meet and Greet", "Sites tagged as Meet and Greet", "fa-hands-helping"),
        new FilterData("access", "Accessible Spaces", "Sites with a number of Accessible Spaces", "fa-wheelchair"),
        new FilterData("p&c", "Parent and Child", "Sites with a number of Parent and Child Spaces", "fa-baby-carriage"),
        //
        new FilterData("cycle", "Cycle", "Sites listed as accepting Bicycles", "fa-bicycle"),
        new FilterData("mcycle", "Motorcycle", "Sites listed as accepting Motorcycles", "fa-motorcycle"),
        //https://trello.com/c/bsPNVhV5/217-remove-mg-airport-filters new FilterData("lorry", "Lorry", "Sites listed as accepting Lorries", "fa-truck"),
        //https://trello.com/c/bsPNVhV5/217-remove-mg-airport-filters new FilterData("coach", "Coach", "Sites listed as accepting Coaches", "fa-shuttle-van"),
        //
        new FilterData("airport", "Airport", "Sites tagged as related to an Airport", "fa-plane-departure"),
        new FilterData("station", "Station", "Sites tagged as related to a Train Station", "fa-subway"),
        new FilterData("town", "Town Centre", "Sites tagged as related to a City/Town Centre", "fa-city")
    ];
}
export class FilterData {
    constructor(id, name, description, faIcon, isAward = false, entails = [], inhibits = []) {
        this.id = id;
        this.name = name;
        this.description = description;
        this.faIcon = faIcon;
        this.isAward = isAward;
        this.entails = entails;
        this.inhibits = inhibits;
        this.selected = false;
        this.disabled = false;
    }
    selectAndDisable() {
        this.selected = true;
        this.disabled = true;
    }
    deselectAndDisable() {
        this.selected = false;
        this.disabled = true;
    }
    reset() {
        this.selected = false;
        this.disabled = false;
    }
}
